/* Carry product context into Shopify's native contact form without sending it elsewhere. */
(() => {
  const form = document.querySelector('form[action*="/contact"]');
  if (!form) return;
  const params = new URLSearchParams(location.search);
  const id = params.get('product') || '';
  if (!/^\d{6,20}$/.test(id)) return;
  const title = (params.get('product_title') || '').slice(0,240);
  const path = params.get('product_url') || '';
  const block = document.createElement('div');
  block.className = 'nm-product-context';
  const label = document.createElement('p');
  label.textContent = title ? 'Your question about: ' + title : 'Your question about product ' + id;
  block.append(label);
  if (/^\/(?:[a-z]{2}\/)?products\/[a-z0-9-]+$/.test(path)) {
    const link = document.createElement('a');
    link.href = path;
    link.textContent = 'Back to product';
    block.append(link);
  }
  const field = document.createElement('input');
  field.type = 'hidden';field.name = 'contact[Product]';field.value = [id,title,path].join(' | ');
  form.prepend(block,field);
})();

/* Clear only the visible header query; native GET search needs no JavaScript. */
(() => {
  const sync = (form) => {
    const input = form.querySelector('[name="q"]');
    const button = form.querySelector('[data-nm-search-clear]');
    if (input && button) {
      form.setAttribute('data-nm-search-enhanced', 'true');
      button.hidden = input.value.length === 0;
    }
  };
  document.querySelectorAll('form.nm-header-search').forEach(sync);
  document.addEventListener('input', (event) => {
    const form = event.target.closest && event.target.closest('form.nm-header-search');
    if (form) sync(form);
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-nm-search-clear]');
    if (!button) return;
    const form = button.closest('form.nm-header-search');
    const input = form && form.querySelector('[name="q"]');
    if (!input) return;
    input.value = '';
    sync(form);
    input.focus();
  });
})();
